/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/minus': {
    width: 30,
    height: 6,
    viewBox: '0 0 30 6',
    data: '<path pid="0" _fill="#000" d="M0 0h30v6H0z"/>'
  }
})
